var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import axios from 'axios';
import { injectable } from 'tsyringe';
import { Constants } from '../../../common/constants';
const instance = axios.create({
    baseURL: Constants.url.google_map_api,
    headers: {
        'Content-Type': 'application/json',
    },
    responseType: 'json',
});
let GoogleMapDataSource = class GoogleMapDataSource {
    async geocoding(address) {
        try {
            const params = {
                language: 'ja',
                sensor: false,
                key: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
                address,
            };
            const result = await instance.get('', { params }).catch((e) => {
                throw e;
            });
            const { lat, lng } = result.data.results[0].geometry.location;
            return { lat, lng };
        }
        catch (e) {
            throw e;
        }
    }
};
GoogleMapDataSource = __decorate([
    injectable()
], GoogleMapDataSource);
export { GoogleMapDataSource };
